export default __webpack_public_path__ + "static/media/map.8d1545b2.png";